import * as React from "react";
import { useMemo } from "react";
import styled from "styled-components";
import { formatPercentage } from "util/NumberFormatting";
const NumberCell = styled.span`
  float: right;
`;
const PercentageField = ({ value }) => {
  const formatted = useMemo(() => formatPercentage(value), [value]);
  return /* @__PURE__ */ React.createElement(NumberCell, { title: String(value) }, formatted);
};
export default PercentageField;
